/* eslint-disable */
const $ = require('jquery');

const gallery = function() {
  const $galleries = $('.js-gallery');
  $galleries.each(function() {
    const $gallery = $(this);
    const $display = $('.gallery-display', $gallery);
    const $navigationitems = $('.gallery-item', $gallery);

	if ($navigationitems.length === 0) return;

    $navigationitems.get(0).classList.add('is-active');
    $navigationitems.on('click', function(e) {
      if ($(this).hasClass('is-active')) {
        return;
      }
      $(this)
        .siblings()
        .removeClass('is-active');
      $(this).addClass('is-active');
      const src = $(this).data('src');
      $('img', $display).attr('src', src);
    });
  });
};

module.exports = gallery;
